import register from '@kpsys/angularjs-register';
import {StatsService} from './stats.service';
import {statsRoutes} from './stats.routes';
import {StatsDataService} from './stats.data-service';

export default register('portaro.features.stats')
    .config(statsRoutes)
    .service(StatsDataService.serviceName, StatsDataService)
    .service(StatsService.serviceName, StatsService)
    .name();